import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, X } from 'lucide-react';
import { Button } from './ui/button';
import { useCompare } from '../context/CompareContext';
import { useMarket } from '../hooks/useMarket';

/**
 * Floating bottom tray that shows up when the user pins at least one property
 * for comparison. Up to 3 can be pinned.
 */
const CompareTray = () => {
  const { ids, count, max, remove, clear } = useCompare();
  const market = useMarket();

  if (count === 0) return null;

  return (
    <div
      data-testid="compare-tray"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-gray-200 bg-white/95 backdrop-blur-sm shadow-[0_-4px_12px_rgba(0,0,0,0.04)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex items-center gap-2 text-gray-800 font-medium">
            <Scale className="h-5 w-5 text-[#7042cc]" />
            <span data-testid="compare-tray-count">
              {count} / {max} pinned for comparison
            </span>
          </div>

          <div className="hidden md:flex items-center gap-2 overflow-x-auto">
            {ids.map((id) => (
              <span
                key={id}
                className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#F5EFFF] border border-[#7042cc]/20 text-[#5b35a8] text-xs font-medium max-w-[140px]"
              >
                <span className="truncate font-mono">{id.slice(-6)}</span>
                <button
                  onClick={() => remove(id)}
                  data-testid={`compare-tray-remove-${id}`}
                  className="hover:bg-[#F5EFFF] rounded-full p-0.5"
                  aria-label="Remove from compare"
                >
                  <X className="h-3 w-3" />
                </button>
              </span>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            variant="ghost"
            size="sm"
            onClick={clear}
            data-testid="compare-tray-clear"
          >
            Clear
          </Button>
          <Link to={market.withPrefix('/compare')}>
            <Button
              size="sm"
              className="bg-[#7042cc] hover:bg-[#5b35a8] text-white"
              disabled={count < 2}
              data-testid="compare-tray-go"
            >
              Compare {count >= 2 ? `(${count})` : '— pin 2+'}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompareTray;
